import React from 'react'

const JSONEditor = ({ value, onChange, error }) => {
    return (
        <div className="space-y-2">
            <label className="block text-sm font-medium">JSON de Entrada</label>
            <textarea
                value={value}
                onChange={(e) => onChange(e.target.value)}
                className={`w-full h-64 p-3 font-mono text-sm rounded-lg border dark:bg-gray-700 dark:border-gray-600 dark:text-white ${
                    error ? 'border-red-500' : 'border-gray-300 focus:border-blue-500'
                } focus:outline-none focus:ring-1 focus:ring-blue-500`}
                placeholder='{"event": "patient_registered", "data": {...}}'
            />
            {error && <p className="text-red-500 text-sm">{error}</p>}
        </div>
    );
};

export default JSONEditor
